export enum CashMovementType {
  Sale = 'sale',
  Reservation = 'reservation',
  Repair = 'repair',
  Withdrawal = 'withdrawal',
}
